import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {Payday} from "../Payday";
import {gsap} from "gsap";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

/**
 * Created by jonas on 2022-09-02.
 */

export class ClawsGrab implements SimplePresentation {

    name:string = "ClawsGrab";

    constructor() {
    }

    public shouldRun():boolean {
        return true;
    }

    public start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline();
        tl.add(() => {
            controller.setSkipCallback(() => {
                tl.progress(1, false)
            });
        });


        const succesfulClaws = Payday.model.succesfulClaws();
        const clawPositions = Payday.model.clawIndices();
        const symbolsOnReels = Payday.reelView.getSymbolsAt(clawPositions);
        const droppedSymbols = symbolsOnReels
            .map((success, clawIndex) => symbolsOnReels[clawIndex].symbolName)
            .filter((symbol, index) => !succesfulClaws[index] && symbol != "X0");

        Payday.reelView.setSuccesfulClaws(succesfulClaws);

        if (symbolsOnReels.some((symbol) => symbol.symbolName != "X0")) {
            if (Payday.apiPlugin.settings.get(APISetting.FAST_SPIN))
                tl.timeScale(1.5);

            tl.add(Payday.reelView.clawsGrab());
            tl.add(() => {Payday.soundPlayer.playSound("clawGoingDown")}, '<')
            tl.add(() => {Payday.soundPlayer.playSound("clawPickingUp")}, '<0.375')
            if (droppedSymbols.some((sym) => sym == "MAX" || sym == "SC" || sym == "X1000"))
                tl.add(() => {Payday.soundPlayer.playSound("clawDroppingLandingBlueBall")}, '<0.75')
            else if (droppedSymbols.length > 0)
                tl.add(() => {Payday.soundPlayer.playSound("clawDroppingLanding")}, '<0.75')
        }

        tl.add(() => {
            controller.finish();
        })
    }
}
